﻿import { ToastType } from '@components';
import { resetAllStores } from '@mobileStore/createAppStore';
import { initializeFeatureFlags } from '@mobileStore/featureFlags/store';
import { logout } from '@mobileStore/logout/services';
import { handleToast } from '@utils/utils';
import { produce } from 'solid-js/store';

import { fetchMobileOfficeDetail, fetchUser } from './services';
import { setMobileUserStore, UserState } from './store';
import { PUBLIC_ROUTES } from '../../../mobile/constants/routes';

export const fetchUserDetails = async () => {
  try {
    await initializeFeatureFlags();
    const user = await fetchUser();
    const officeDetail = await fetchMobileOfficeDetail(user.officeId);
    setMobileUserStore(
      produce((draft: UserState) => {
        draft.user = user;
        draft.officeDetail = officeDetail ?? null;
        draft.loggedIn = true;
      }),
    );
    setMobileUserStore('isLoading', false);
    return true;
  } catch (error) {
    setMobileUserStore(
      produce((draft: UserState) => {
        draft.isError = true;
        draft.isLoading = false;
      }),
    );
    handleToast(ToastType.Error, 'Failed to fetch user details');
    localStorage.removeItem('atg-auth');
    if (!PUBLIC_ROUTES.includes(window.location.pathname)) {
      const params = new URLSearchParams({
        auth_url: window.location.pathname,
      });
      window.location.href = '/account/login?' + params.toString();
    }
    return false;
  }
};

export const LogUserOut = async (cb?: () => void) => {
  resetAllStores();
  window.localStorage.clear();
  window.sessionStorage.clear();
  await logout();
  cb && cb(); // Note : Run anything after logout like closing drawer, etc.
  window.location.href = '/account/login?auth_url=' + window.location.pathname;
};
